<style lang="scss" scoped>
.slide-16 {
  background-image: url("../../../assets/module5/slide16/bg-02.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 60px;
  padding-left: 80px;
}
h1 {
  font-size: 53px;
  color: #3b7fc2;
  text-align: center;
  span {
    color: white;
    font-size: 67px;
  }
}
p {
  color: #09509c;
  max-width: 515px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  big {
    text-transform: uppercase;
    font-size: 44px;
    font-family: "Kookycat-FASTcaps";
  }
}
.right {
  padding-top: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.num {
  transition: all 0.2s ease-out;
  color: #09509c;
  font-size: 34px;
  display: flex;
  margin-top: 30px;
  align-items: center;
  text-align: left;
  counter-increment: section;
  cursor: pointer;
  position: relative;
  &:hover {
    transform: scale(1.1);
  }
  &:first-of-type {
    margin-right: 150px;
  }
  &:nth-of-type(2) {
    margin-left: 60px;
  }
  &:nth-of-type(3) {
    margin-right: 200px;
  }
  &:nth-of-type(4) {
    max-width: 470px;
    margin-left: 100px;
  }
  &:nth-of-type(5) {
    margin-left: auto;
    margin-right: 150px;
  }
  &:nth-of-type(6) {
    max-width: 400px;
    margin-left: 200px;
  }
  &:before {
    content: counter(section);
    display: inline-block;
    margin-right: 20px;
    font-size: 78px;
    color: white;
    vertical-align: middle;
    font-family: "Kookycat-FASTcaps";
    transform: translateY(10px);
  }
  &:after {
    border-radius: 20px;
    transition: width 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    content: "";
    display: block;
    left: 0;
    top: 50%;
    height: 15px;
    background-color: #09509c;
    position: absolute;
    width: 0%;
    transform: rotate(-5deg);
  }
  &.strike:after {
    width: 100%;
  }
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 99999999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
  width: 100%;
  border-radius: 0;
}
</style>

<template>
  <div class="slide-16">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>

    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 15"
        src="@/assets/module5/slide16/timmy-02.png"
        class="chars delay-4"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 15"
        src="@/assets/module5/slide16/img-02.png"
        class="chars delay-1"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 15"
        src="@/assets/module5/slide16/images-02.png"
        class="chars delay-2"
      />
    </transition>

    <div class="flex">
      <div class="flex-1">
        <transition name="scale" appear>
          <h1 v-show="slideIndex == 15">
            Now before we go let’s practice one last time
            <span>
              what to tell the ambulance
            </span>
            if one of the 103 symptoms happen to someone&nbsp;we&nbsp;love.
          </h1>
        </transition>
      </div>
      <transition name="scale" appear>
        <div class="flex-1 right delay-3" v-show="slideIndex == 15">
          <p>
            Here’s a little test, click on the sentences you would you
            <big>not</big> say to the operator when you dial 103
          </p>
          <div class="num" @click="selectAnswer($event)">My name is ....</div>
          <br />
          <div class="num" @click="selectAnswer($event, true)">
            My favourite<br />animal is a dog ....
          </div>
          <div class="num" @click="selectAnswer($event)">I live at ....</div>
          <div class="num" @click="selectAnswer($event)">
            My grandma isn’t speaking properly, her words are mixed up.
          </div>
          <div class="num" @click="selectAnswer($event, true)">
            I love icecream.
          </div>
          <div class="num" @click="selectAnswer($event)">
            Please send an ambulance.
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  data() {
    return {
      showVid: false
    };
  },
  methods: {
    play() {
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    },
    selectAnswer(e, correct = false) {
      if (correct) {
        e.target.classList.add("strike");
        if (document.querySelectorAll(".strike").length === 2)
          setTimeout(() => this.play(), 500);
      } else {
        e.target.classList.add(
          "animate__animated",
          "animate__headShake",
          "done"
        );
        setTimeout(() => {
          e.target.classList.remove("animate__animated", "animate__headShake");
        }, 1000);
      }
    }
  }
};
</script>
